import type { Moment } from "moment";
import type { FormInstance } from "antd";
import { IOfferTarifficationFormData } from "../context/types";
import { ServiceRate } from "../../../lib/types";
import { getNewServiceRate } from "./getNewServiceRate";

interface Props {
  form: FormInstance<IOfferTarifficationFormData<Moment>>;
  taxRate: string;
  isPacketTariff: boolean;
  currencyId: number | undefined;
}

export const onAddPrice = (props: Props) => {
  const { form, taxRate, isPacketTariff, currencyId } = props;
  const serviceRates = form.getFieldValue("serviceRates") || [];
  const addedRate: Partial<ServiceRate> = getNewServiceRate({
    currencyId,
    isPacketTariff,
    taxRate,
  });
  const updatedServiceRates = [...serviceRates, addedRate];
  form.setFieldsValue({ serviceRates: updatedServiceRates });
};
